<template>
  <NuxtLayout>
    <HeroHeader class="heroHeader--Homepage">
      <ReservationPanel />
    </HeroHeader>
  
    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  // do podataka za page se dolazi preko propa "page"
  const props = defineProps({
    page: {
      type: Object
    }
  })
  
  const { initialData, socialNetworks } = useSetup();
  const envVariables = useRuntimeConfig();

  useHead({
    htmlAttrs: {
      class: 'fixedHeader fixedHeader--WithoutTopPadding',
    },
  })

  useJsonld(() => ({
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": "Aminess",
    "alternateName": "Aminess d.d.",
    "url": `${ envVariables.public.domain || '' }/`,
    "email": `${ initialData?.value?.contact?.email || '' }`,
    "telephone": `${ initialData?.value?.contact?.phone_number || '' }`,
    "logo": `${ envVariables.public.domain || '' }/resources/images/icons/logo.svg`,
    "sameAs": [
      ...socialNetworks.value.map((item) => item.href),
    ],
  }))

  useJsonld(() => ({
    "@context": "http://schema.org",
    "@type": "WebSite",
    "name" : "Aminess Hotels & Resorts",
    "url": `${ envVariables.public.domain || '' }/`,
  }))
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_homepage.scss');
</style>